/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../../models/Node';
import { Operation } from '../../../models/common/Operation';
import { ReferenceUtil } from '../../../util/ReferenceUtil';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { OasOperation } from '../../../../openapi/models/OasOperation';
import { OasParameter } from '../../../../openapi/models/OasParameter';
import { OasPathItem } from '../../../../openapi/models/OasPathItem';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasParameterUniquenessValidationRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * Given a 'in' and a 'name' for a parameter, return the # of parameters in the list
     * of parameters that match.
     * @param {OasParameter[]} params
     * @param {string} paramName
     * @param {string} paramIn
     * @return {number}
     * @private
     */
    /*private*/ getParamCount(params : Array<OasParameter>, paramName : string, paramIn : string) : number {
        let count : number = 0;
        for(let index217=0; index217 < params.length; index217++) {
            let param = params[index217];
            {
                if(this.hasValue(param) && this.equals(param.name, paramName) && this.equals(param.in, paramIn)) {
                    count++;
                }
            }
        }
        return count;
    }

    /**
     * Validates that all parameter name and "in" combinations are unique
     * @param {OasParameter[]} params
     * @private
     */
    /*private*/ ensureUnique(params : Array<OasParameter>) {
        if(!this.hasValue(params)) {
            return;
        }
        let resolvedParams : Array<OasParameter> = <any>([]);
        params.forEach(((resolvedParams) => {
            return (param) => {
                let resolveNodeRef : Node = ReferenceUtil.resolveNodeRef$io_apicurio_datamodels_core_models_Node(param);
                if(resolveNodeRef != null && resolveNodeRef instanceof <any>OasParameter) {
                    /* add */(resolvedParams.push(<OasParameter>resolveNodeRef)>0);
                } else {
                    /* add */(resolvedParams.push(param)>0);
                }
            }
        })(resolvedParams));
        let idx : number = 0;
        for(let index218=0; index218 < resolvedParams.length; index218++) {
            let resolvedParam = resolvedParams[index218];
            {
                if(this.hasValue(resolvedParam) && this.hasValue(resolvedParam.in) && this.hasValue(resolvedParam.name) && !this.equals(resolvedParam.in, "body")) {
                    let count : number = this.getParamCount(resolvedParams, resolvedParam.name, resolvedParam.in);
                    if(count > 1) {
                        let param : OasParameter = /* get */params[idx];
                        this.report(param, "in", this.map("paramIn", resolvedParam.in, "paramName", resolvedParam.name));
                    }
                }
                idx++;
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        this.ensureUnique(node.parameters);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        let op : OasOperation = <OasOperation>node;
        this.ensureUnique(op.parameters);
    }
}
OasParameterUniquenessValidationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.other.OasParameterUniquenessValidationRule";
OasParameterUniquenessValidationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




